import defaultTheme from './default/theme';
import toyotaTheme from './toyota/theme';

const THEME = process.env.REACT_APP_THEME_BRAND;

const theme = {
  ...{
    ...toyotaTheme,
    ...defaultTheme,
  }[THEME],
};

export default theme;
